<template>
    <div class="">
        <div class="container py-3 mediaHideOnDesctop">
            <div class="row">
                <div class="col-12">
                    <div class="pickupLocationBox">
                        <div class="text h6">
                            Pickup from {{ cart.business.fullAddress() }} - {{ cart.calcOrderTime() }}
                        </div>
                        <router-link class="changeBtn buttonTextSmall" :to="{name:'Locations'}">
                            Change
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="descktopMediaBox">
            <div class="pickupLocationBox">
                <div class="text h6">
                    <span>Pickup from:</span> {{ cart.business.fullAddress() }} - {{ cart.calcOrderTime() }}
                </div>
                <router-link class="changeBtn buttonTextSmall" :to="{name:'Locations'}">
                    Change
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LocationBar",
        computed: {
            cart(){
                return this.$store.state.cart.cart;
            }
        }
    }
</script>
